import { FilterCriteria } from "../../data/type";

const traffic_type = [
    "車朝",
    "車昼",
    "車夜",
    "車夜（モバ空）",
    "車休祝日",
    "車休祝日（モバ空）",
    "人朝",
    "人朝特定",
    "人昼",
    "人昼特定",
    "人夜",
    "人夜（モバ空）",
    "人夕方特定",
    "人休祝日",
    "人夕方特定（モバ空）",
    "人休祝日（モバ空）" 
]

const counter = [
    'top_left_count',
    'top_bottom_count',
    'top_right_count',
    'right_top_count',
    'right_left_count',
    'right_bottom_count',
    'bottom_right_count',
    'bottom_top_count',
    'bottom_left_count',
    'left_bottom_count',
    'left_right_count',
    'left_top_count'
]

const count_type = [
    'top_left_type',
    'top_bottom_type',
    'top_right_type',
    'right_top_type',
    'right_left_type',
    'right_bottom_type',
    'bottom_right_type',
    'bottom_top_type',
    'bottom_left_type',
    'left_bottom_type',
    'left_right_type',
    'left_top_type'
]

const count_number = [
    '①',
    '②',
    '③',
    '④',
    '⑤',
    '⑥',
    '⑦',
    '⑧',
    '⑨',
    '⑩',
    '⑪',
    '⑫'
]

export const changeHistoryTableName = (tableNameMaster: any, table_physics_name: string, logData: any) => {
    let table_logic_name = table_physics_name
    tableNameMaster.map((row: any) => {
        if (row.table_physics_name === table_physics_name) {
            table_logic_name = row.table_logic_name
        }
    })

    if (table_physics_name === 'location_trade_area') {
        const subKey = JSON.parse(
            logData.sub_key.includes("'")
            ? JSON.stringify(logData.sub_key).replaceAll('"', '').replaceAll("'", '\"')
            : logData.sub_key
        )
        if ("town_district" in subKey) {
            table_logic_name = table_logic_name + "　" + subKey.town_district
        }
    }
    if (table_physics_name === 'location_conflict') {
        try {
            const subKey = JSON.parse(
                logData.sub_key.includes("'")
                ? JSON.stringify(logData.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                : logData.sub_key
            )
            if (subKey.conflict_type === '0') {
                table_logic_name = table_logic_name + "（CVS）" 
            } else if (subKey.conflict_type === '1') {
                table_logic_name = table_logic_name + "（CVS）"
            } else if (subKey.conflict_type === '2') {
                table_logic_name = table_logic_name + "（SMDS）"
            } else if (subKey.conflict_type === '3') {
                table_logic_name = table_logic_name + "（SMDS）"
            }
        } catch (e) {}
    }
    if (table_physics_name === 'location_impact') {
        try {
            const subKey = JSON.parse(
                logData.sub_key.includes("'")
                ? JSON.stringify(logData.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                : logData.sub_key
            )
            if (Object.keys(subKey).indexOf('tenpo_name') !== -1) {
                table_logic_name = table_logic_name + "<br>" + subKey.tenpo_name
            }    
        } catch (e) {}
    }

    if (logData.target_table === 'location_impact_counter') {
        try {
            const subKey = JSON.parse(
                logData.sub_key.includes("'")
                ? JSON.stringify(logData.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                : logData.sub_key
            )
            if (Object.keys(subKey).indexOf('tenpo_name') !== -1) {
                table_logic_name = table_logic_name + "<br>" + subKey.tenpo_name
            }
            if (Object.keys(subKey).indexOf('route') !== -1) {
                table_logic_name = table_logic_name + "<br>" + subKey.route
            }
            if (Object.keys(subKey).indexOf('intersection') !== -1) {
                table_logic_name = table_logic_name + "<br>" + "（カウンター " + subKey.intersection + "）"
            }
        } catch (e) {}
    }

    return table_logic_name.replaceAll("<br>", "\n")
}

export const changeHistoryColumnName = (tableNameMaster: any, column_physics_name: string, logData: any) => {
    let column_logic_name = column_physics_name
    tableNameMaster.map((row: any) => {
        if (row.column_physics_name === column_physics_name) {
            column_logic_name = row.column_logic_name
        }
    })

    if (logData.target_table === 'location_conflict') {
        try {
            const subKey = JSON.parse(
                logData.sub_key.includes("'")
                ? JSON.stringify(logData.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                : logData.sub_key
            )
            if (Object.keys(subKey).indexOf('tenpo_name') !== -1) {
                column_logic_name = subKey.tenpo_name + "<br>" + column_logic_name
            }
        } catch (e) {}
    }
    if (logData.target_table === 'location_traffic') {
        try {
            const subKey = JSON.parse(
                logData.sub_key.includes("'")
                ? JSON.stringify(logData.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                : logData.sub_key
            )
            column_logic_name = traffic_type[subKey.traffic_type] + "<br>" + column_logic_name
        } catch (e) {}
    }
    if (logData.target_table === 'location_impact_counter') {
        if (counter.includes(logData.target_column)) {
            // カウント
            column_logic_name = column_logic_name + (count_number[counter.indexOf(logData.target_column)])
        } else if (count_type.includes(logData.target_column)) {
            // カウントタイプ
            column_logic_name = column_logic_name + (count_number[count_type.indexOf(logData.target_column)])
        }
    }
    // 改行置換
    return column_logic_name.replaceAll("<br>", "\n")
}


export const changeHistorySelecterDisplay = (codeMaster: any, key: string, code_value: string) => {
    let code_display = code_value
    let search_key = key
    // common系の場合検索キーの変更
    if ([
        'handle_category_tobacco',
        'handle_category_liquor'
    ].includes(search_key)) {
        search_key = 'marubatu'
    } else if ([
            'handle_category_parking',
            'conflict_median_strip',
            'cut_survey',
        ].includes(search_key)) {
            search_key = 'common_yesnone_kana'
    } else if ([
            'median_strip_select',
            'median_strip_select2',
            'median_strip_select3',
            'median_strip_select4',
            'sidewalk_select',
            'sidewalk_select2',
            'sidewalk_select3',
            'sidewalk_select4',
            'traffic_signal_etc_forward_select',
            'traffic_signal_etc_forward_select2',
            'traffic_signal_etc_forward_select3',
            'traffic_signal_etc_forward_select4',
            'traffic_signal_etc_front_location_select',
            'traffic_signal_etc_front_location_select2',
            'traffic_signal_etc_front_location_select3',
            'traffic_signal_etc_front_location_select4',
        ].includes(search_key)) {
            search_key = 'common_yesnone'
    } else if ([
            'plan_area_shared_road',
            'conflict_shared_road',
        ].includes(search_key)) {
            search_key = 'common__shared_road'
    } else if ([
            'car_another_survey',
            'people_another_survey',
        ].includes(search_key)) {
            search_key = 'separate_investigation'
    } else if ([
            'others_facility_1',
            'others_facility_2',
            'others_facility_3',
            'others_facility_4',
        ].includes(search_key)) {
            search_key = 'others_facility'
    } else if (count_type.includes(search_key)) {
            search_key = 'impact_count_type'
    }
    if (codeMaster) {
        if (codeMaster[search_key] && code_value !== '' && code_value !== undefined) {
            codeMaster[search_key].filter((row: any) => {
                if (row.code_value === code_value.toString()) {
                    code_display = row.code_display
                }
            })
        }
    }

    return code_display.replaceAll("<br>", "\n")
}

// データにsort_columnを追加する関数
export const addSortColumnToData = (data: any[], codeMaster: any, tableNameMaster: any) => {
    if (!codeMaster?.page_filter || !Array.isArray(codeMaster.page_filter)) {
        return data;
    }

    return data.map((item: any) => {
        const tableName = changeHistoryTableName(tableNameMaster, item.target_table, item);
        let sortColumn = null;

        // 完全一致を優先して、部分一致もチェック
        for (const pageFilter of codeMaster.page_filter) {
            if (pageFilter.code_display) {
                // 完全一致を最優先
                if (tableName === pageFilter.code_display) {
                    sortColumn = pageFilter.sort_column;
                    break;
                }
                // 完全一致がない場合の部分一致（sortColumnがまだ設定されていない場合のみ）
                if (sortColumn === null && tableName.includes(pageFilter.code_display)) {
                    sortColumn = pageFilter.sort_column;
                }
            }
        }

        // sort_columnを追加したアイテムを返す
        return {
            ...item,
            sort_column: sortColumn
        };
    });
};

// フィルタオプションを生成する関数
export const generateFilterOptions = (data: any[], codeMaster: any) => {
    // 修正者の重複除去とソート（昇順）
    const editorsSet = new Set(data.map((item: any) => item.update_name).filter(Boolean));
    
    // 枝の重複除去とソート（昇順）
    const branchesSet = new Set(data.map((item: any) => item.branch).filter(Boolean));
    
    // ページフィルタ：codeMaster.page_filter を sort_column で並び替え
    const pages = codeMaster?.page_filter?.sort((a: any, b: any) => (a.sort_column || 0) - (b.sort_column || 0)) || [];
    
    return {
        editors: Array.from(editorsSet).sort(), // Set → 配列変換 → 昇順ソート
        branches: Array.from(branchesSet).sort(), // Set → 配列変換 → 昇順ソート
        pages: pages, // sort_column順で並び替え済み
    };
};

// フィルタを適用する関数
export const applyFilter = (data: any[], filters: FilterCriteria, tableNameMaster: any) => {
    let filteredData = data.slice();

    // 日付フィルタ
    // 開始日が設定されている場合：その日以降（その日を含む）のデータを表示
    if (filters.startDate) {
        filteredData = filteredData.filter((item: any) => {
            const dayjs = require("dayjs");
            const itemDate = dayjs(item.publish_time);
            return itemDate.isAfter(filters.startDate) || itemDate.isSame(filters.startDate, "day");
        });
    }

    // 終了日が設定されている場合：その日以前（その日を含む）のデータを表示
    if (filters.endDate) {
        filteredData = filteredData.filter((item: any) => {
            const dayjs = require("dayjs");
            const itemDate = dayjs(item.publish_time);
            return itemDate.isBefore(filters.endDate) || itemDate.isSame(filters.endDate, "day");
        });
    }

    // 修正者フィルタ（複数選択対応）
    if (filters.editor && filters.editor.length > 0) {
        filteredData = filteredData.filter((item: any) => 
            filters.editor.includes(item.update_name)
        );
    }

    // 枝フィルタ（複数選択対応）
    if (filters.branch && filters.branch.length > 0) {
        filteredData = filteredData.filter((item: any) => 
            filters.branch.includes(item.branch)
        );
    }

    // ページフィルタ（複数選択対応）- changeHistoryTableNameで変換後の値で絞り込み
    if (filters.page && filters.page.length > 0) {
        filteredData = filteredData.filter((item: any) => {
            // changeHistoryTableName関数で変換した値と比較
            const tableName = changeHistoryTableName(tableNameMaster, item.target_table, item);
            // 選択されたページのいずれかがtableNameに含まれているかチェック
            return filters.page.some((selectedPage: string) => tableName.includes(selectedPage));
        });
    }

    return filteredData;
};

// ページソート関数
export const pageSort = (data: any[]) => {
    return [...data].sort((a: any, b: any) => {
        // sort_column ASC (昇順) のみ
        // ソート順が未定義の場合は99番目（最後）に配置
        const sortColumnA = a.sort_column || 99;
        const sortColumnB = b.sort_column || 99;
        return sortColumnA - sortColumnB;
    });
};

// 日付ソート関数
export const dateSort = (data: any[]) => {
    return [...data].sort((a: any, b: any) => {
        // publish_time DESC (日付降順)
        const dateA = new Date(a.publish_time);
        const dateB = new Date(b.publish_time);
        if (dateA.getTime() !== dateB.getTime()) {
            return dateB.getTime() - dateA.getTime(); // DESC
        }
        
        // plan_area_id ASC (候補地ID昇順)
        if (a.plan_area_id !== b.plan_area_id) {
            return a.plan_area_id.localeCompare(b.plan_area_id);
        }
        
        // branch ASC (枝昇順)
        if (a.branch !== b.branch) {
            return a.branch.localeCompare(b.branch);
        }
        
        // status_seq ASC (ステータス順序昇順)
        if (a.status_seq !== b.status_seq) {
            return (a.status_seq || 0) - (b.status_seq || 0);
        }
        
        // target_table ASC (対象テーブル昇順)
        if (a.target_table !== b.target_table) {
            return a.target_table.localeCompare(b.target_table);
        }
        
        // target_column ASC (対象カラム昇順)
        return a.target_column.localeCompare(b.target_column);
    });
};
